const Style = {

  paginate: 'inline-block mb-4',
  button: 'float-left relative',
  counter: 'float-left mt-[-.175em] mx-2 text-sm',

}

export default Style;